'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

var generateShimmerCss = (_ref => {
  let {
    start,
    stop,
    size
  } = _ref;
  return styled.css(["background-image:linear-gradient( to right,#ececec 0%,#ececec 45%,#f8f8f8 50%,#ececec 55%,#ececec 100% );background-size:", ";animation-duration:2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:", ";"], size, styled.keyframes(["from{background-position:", " 0;}to{background-position:", " 0;}"], start, stop));
});

exports["default"] = generateShimmerCss;
